/* global __app_id */
import { collection, getDocs } from 'firebase/firestore';

// ==============================================================================
// 🛑 IMPORTANT: KEEP THE FOLLOWING LINES for your environment
// This block initializes the client-side database connection.
import { getFirestore } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-app-id';

// Fallback Configuration (As provided in your original code)
const firebaseConfig = {
    apiKey: "AIzaSyCrP0C-XnF2rurbLmRp1KkIw2WveIOuBDY",
    authDomain: "hopbon-webapp.firebaseapp.com",
    projectId: "hopbon-webapp", 
    storageBucket: "hopbon-webapp.appspot.com",
    messagingSenderId: "372557747897",
    appId: "1:372557747897:web:bac648296de50664986d68",
    measurementId: "G-QP4E79LKR2"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
// ==============================================================================

const FIRESTORE_COLLECTION = 'products'; // Your correct collection name

/**
 * Fetches all product data from the public Firestore database collection.
 * @returns {Promise<Array<Object>>} A promise that resolves to the array of product objects.
 */
export async function allProducts() {
    try {
        // 1. Define the public collection path - FIX APPLIED HERE
        // It now correctly references the top-level 'products' collection.
        const productsCollectionRef = collection(
            db, 
            FIRESTORE_COLLECTION // This resolves to 'products'
            // The long, nested path was removed.
        );

        // 2. Fetch all documents
        const snapshot = await getDocs(productsCollectionRef);
        
        if (snapshot.empty) {
            console.log("No matching products found in Firestore.");
            return [];
        }

        // 3. Map the Firestore documents to the required product array format
        const productList = snapshot.docs.map((doc, index) => {
            const data = doc.data();
            
            return {
                index: index + 1,
                id: doc.id, // e.g., 'F-05'
                name: data.name || 'Untitled Product', 
                // The 'imageUrls' field from Firestore becomes the 'image' field for compatibility
                image: data.imageUrls || [], 
                category: data.category || 'Uncategorized',
                description: data.description || 'No description provided.',
                price: data.price || 0
            };
        });

        console.log(`Successfully fetched ${productList.length} products from Firestore.`);
        return productList;

    } catch (error) {
        console.error("Error fetching products from Firestore:", error);
        return []; 
    }
}

// Exporting the function
export default allProducts;